import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, BodyText, Checkbox, Skeleton } from '@gaiads/telia-react-component-library';
import { LocaleResponse, LocalPropertyValue, Price } from '@cdaas/api-clients/dist/product-service-openapi';

import ProductsListItemComponent from './ProductsListItem';
import ProductsListVariantItem from './ProductsListVariantItem';
import { AdminProductType } from '../../../store/adminProducts';

interface ListItem {
  parent_id?: number;
  properties?: LocalPropertyValue[];
  prices?: Price[];
  variant_id?: number;
}

export type ProductsListItem = AdminProductType & ListItem;

interface ProductsListProps {
  products: ProductsListItem[];
  tableHeaders: ProductTableHeaders;
  locales: LocaleResponse[];
  selectAll: boolean;
  onProductChecked: (product: ProductsListItem) => void;
  onAllChecked: () => void;
  onClickProductRow: (product: ProductsListItem) => void;
  onOpenProductRow: (product: ProductsListItem) => void;
  isSelected: (product: ProductsListItem) => boolean;
  isOpened: (product: ProductsListItem) => boolean;
  isLoaded: (product: ProductsListItem) => boolean;
}

type TableHeader = string | undefined;
export type ProductTableHeaders = [
  TableHeader,
  TableHeader,
  TableHeader,
  TableHeader,
  TableHeader,
  TableHeader,
  TableHeader,
  TableHeader,
  TableHeader,
];

const getProductVariants = (products: ProductsListItem[], parentId: number) => {
  return products.filter(product => product.parent_id === parentId);
};

export default function ProductsList(props: ProductsListProps) {
  const {
    locales,
    selectAll,
    tableHeaders,
    products,
    onAllChecked,
    onProductChecked,
    onClickProductRow,
    onOpenProductRow,
    isSelected,
    isOpened,
    isLoaded,
  } = props;
  const { t } = useTranslation('productsscreen');
  const mainProducts = products.filter(product => !product.parent_id);

  return (
    <Table className={'products-table'}>
      <thead>
        <Table.Row>
          <Table.HeaderCell type="checkbox">
            <Checkbox
              checked={selectAll}
              onChange={() => {
                onAllChecked();
              }}
            />
          </Table.HeaderCell>
          {tableHeaders.map((header, index) => (
            <Table.HeaderCell key={`table-header-${index}`}>
              <BodyText fontWeight="bold">{header && t(`productTableHeader.${header}`)}</BodyText>
            </Table.HeaderCell>
          ))}
        </Table.Row>
      </thead>
      <tbody>
        {mainProducts.map((product: ProductsListItem, index) => (
          <ProductsListItemComponent
            key={`variants-row-${index}`}
            product={product}
            locales={locales}
            onProductChecked={onProductChecked}
            onClickProductRow={onClickProductRow}
            onOpenProductRow={onOpenProductRow}
            selected={isSelected(product)}
            open={isOpened(product)}
          >
            {isOpened(product) && !isLoaded(product) ? (
              <Table.Row className="telia-react-table_row__child daas-product-table__skeleton-row">
                <Table.Cell colSpan={9}>
                  <Skeleton widthInPercentages={100} height={64.5} />
                </Table.Cell>
              </Table.Row>
            ) : (
              getProductVariants(products, product.id).map((productVariant, ind) => (
                <ProductsListVariantItem
                  key={`subrow-${ind}`}
                  variant={productVariant}
                  onProductChecked={onProductChecked}
                  onClickProductRow={onClickProductRow}
                  selected={isSelected(productVariant)}
                  open={isOpened(product)}
                />
              ))
            )}
          </ProductsListItemComponent>
        ))}
      </tbody>
    </Table>
  );
}
